import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Who the person is (member, platform super admin). What they may do is can() in lib/permissions.
export function userSatisfiesRole(user: { roles?: string[] }, role: string): boolean {
  return user.roles?.includes(role) ?? false;
}

export function toYoutubeEmbedUrl(url: string): string | null {
  try {
    const parsed = new URL(url);
    let videoId: string | null = null;

    if (parsed.hostname === 'youtu.be') {
      videoId = parsed.pathname.slice(1);
    } else if (parsed.hostname.includes('youtube.com')) {
      videoId = parsed.searchParams.get('v');
    }

    return videoId ? `https://www.youtube.com/embed/${videoId}` : null;
  } catch {
    return null;
  }
}


// Only techniques and katas have a reference video; other items are text-only.
export function itemSupportsVideo(item: { type: string; category: string }): boolean {
  return item.type === 'technique' || item.category === 'kata';
}
